export const SERVER_LINK = process.env.REACT_APP_SERVER_LINK ? process.env.REACT_APP_SERVER_LINK : "";
